export default __webpack_public_path__ + "static/media/ic_matic_64.fc763488.svg";